export default "__VITE_ASSET__Bsd3YDUs__"